package dev.moetz.chatoverlay.design

import dev.moetz.materialize.mFooter
import dev.moetz.chatoverlay.localization.Localization
import kotlinx.browser.window
import react.ChildrenBuilder

fun ChildrenBuilder.mFooter() {
    mFooter(
        socialLink = "https://moetz.dev",
        pageName = Localization["page_title"],
        gitUrl = "https://gitlab.moetz.dev/twitch/chatoverlay",
        isOpenSource = true,
        languages = Localization.Language.entries.map { it.name },
        onSelectLanguage = {
            Localization.setLanguage(Localization.Language.valueOf(it))
            window.location.reload()
        },
        buyMeACoffeeName = "flow_mo7",
        linksOnRightSide = listOf(
            "Privacy Policy" to "https://moetz.dev/privacy",
        )
    )
}
